// ################ CHARTDATAX-CLASS ################
class ChartDataX {
  // ######## CONSTANTS ########
  static get ACTIVE() {
    return "ACTIVE";
  }
  static get ACTIVEEMPLOYEE() {
    return "ACTIVE-EMPLOYEE";
  }
  static get CUSTOMER() {
    return "CUSTOMER";
  }
  static get EMPLOYEE() {
    return "EMPLOYEE";
  }
  static get FORM() {
    return "FORM";
  }
  static get LOCATION() {
    return "LOCATION";
  }
  static get PARTNER() {
    return "PARTNER";
  }
  static get PARTNERGROUP() {
    return "PARTNERGROUP";
  }

  // ######## CONSTRUCTOR ########
  constructor(data) {
    this.allEdges = new SetX();
    this.active = new SetX();
    this.activeEmployee = new SetX();

    this.mPartnerGroup = new Map();
    this.mPartner = new Map();
    this.mLocation = new Map();
    this.mForm = new Map();
    this.mEmployee = new Map();
    this.mCustomer = new Map();

    this.aPartnerGroup = [];
    this.aPartner = [];
    this.aLocation = [];
    this.aForm = [];
    this.aEmployee = [];
    this.aCustomer = [];

    this.eIndex = 0;

    for (let i = 0; i < data.length; ++i) {
      const partnerGroup = data[i];
      const partnerGroupId = partnerGroup.partnergroup.id;
      let partnerGroupName = partnerGroup.partnergroup.name;
      let partnerGroupNode = this.mPartnerGroup.get(partnerGroupId);

      const partners = partnerGroup.partners;

      if (!partnerGroupNode) {
        this.mPartnerGroup.set(
          partnerGroupId,
          new NodeX(partnerGroup, strToHexColor(partnerGroupName))
        );
        partnerGroupNode = this.mPartnerGroup.get(partnerGroupId);

        partnerGroupName =
          partnerGroupName.charAt(0).toUpperCase() + partnerGroupName.slice(1);
        this.aPartnerGroup.push([partnerGroupId, partnerGroupName]);
      } else {
        partnerGroupNode.addRef(partnerGroup);
      }

      if (partners.length === 0) {
        partnerGroupNode.addEdge(this.eIndex);
        this.allEdges.add(this.eIndex);
        ++this.eIndex;
      } else {
        for (let j = 0; j < partners.length; ++j) {
          const partner = partners[j];
          const partnerId = partner.partner.id;
          const partnerName = partner.partner.name;
          let partnerNode = this.mPartner.get(partnerId);

          const employees = partner.employees;
          const forms = partner.forms;
          const locations = partner.locations;

          if (!partnerNode) {
            this.mPartner.set(
              partnerId,
              new NodeX(partner, strToHexColor(partnerName))
            );
            partnerNode = this.mPartner.get(partnerId);

            this.aPartner.push([partnerId, partnerName]);
          } else {
            partnerNode.addRef(partner);
          }

          // EMPLOYEES & FORMS & LOCATIONS
          if (
            employees.length === 0 &&
            forms.length === 0 &&
            locations.length === 0
          ) {
            partnerGroupNode.addEdge(this.eIndex);
            partnerNode.addEdge(this.eIndex);
            this.allEdges.add(this.eIndex);
            ++this.eIndex;
          } else {
            // EMPLOYEES
            for (let k = 0; k < employees.length; ++k) {
              const employee = employees[k];
              const employeeId = employee.id;
              const employeeName = employee.name;
              const employeeActive = employee.active_for_partner;
              let employeeNode = this.mEmployee.get(employeeId);
              employee.partner_id = partnerId;
              if (!employeeNode) {
                this.mEmployee.set(
                  employeeId,
                  new NodeX(employee, strToHexColor(employeeName))
                );
                employeeNode = this.mEmployee.get(employeeId);

                this.aEmployee.push([employeeId, employeeName, employeeActive]);
              } else {
                employeeNode.addRef(employee);
              }

              partnerGroupNode.addEdge(this.eIndex);
              partnerNode.addEdge(this.eIndex);
              employeeNode.addEdge(this.eIndex);
              this.allEdges.add(this.eIndex);

              if (employee.active_for_partner && employee.active) {
                this.activeEmployee.add(this.eIndex);
              }

              ++this.eIndex;
            }

            // FORMS
            for (let k = 0; k < forms.length; ++k) {
              const form = forms[k];
              const formId = form.id;
              const formName = form.name;
              const formVersion = form.version;
              const formActive = form.active;
              let formNode = this.mForm.get(formId);

              if (!formNode) {
                this.mForm.set(
                  formId,
                  new NodeX(form, strToHexColor(formName))
                );
                formNode = this.mForm.get(formId);

                this.aForm.push([formId, formName, formVersion]);
              } else {
                formNode.addRef(form);
              }

              partnerGroupNode.addEdge(this.eIndex);
              partnerNode.addEdge(this.eIndex);
              formNode.addEdge(this.eIndex);
              this.allEdges.add(this.eIndex);
              if (formActive) {
                this.active.add(this.eIndex);
              }
              ++this.eIndex;
            }

            // LOCATIONS
            for (let k = 0; k < locations.length; ++k) {
              const location = locations[k];
              const locationId = location.id;
              const locationName = location.name;
              const locationAddress = location.adress;
              let locationNode = this.mLocation.get(locationId);

              if (!locationNode) {
                locationNode = this.mLocation.set(
                  locationId,
                  new NodeX(location, strToHexColor(locationName))
                );
                locationNode = this.mLocation.get(locationId);

                this.aLocation.push([
                  locationId,
                  locationName,
                  locationAddress,
                ]);
              } else {
                locationNode.addRef(location);
              }

              partnerGroupNode.addEdge(this.eIndex);
              partnerNode.addEdge(this.eIndex);
              locationNode.addEdge(this.eIndex);
              this.allEdges.add(this.eIndex);
              ++this.eIndex;
            }
          }
        }
      }
    }

    // !!! DEEP COPY BEFORE SET STATISTICS !!!
    this.allInitEdges = this.allEdges;
    this.initActive = this.active;
    this.initActiveEmployee = this.activeEmployee;
    this.mInitPartnerGroup = this.mPartnerGroup;
    this.mInitPartner = this.mPartner;
    this.mInitLocation = this.mLocation;
    this.mInitForm = this.mForm;
    this.mInitEmployee = this.mEmployee;
    this.mInitCustomer = this.mCustomer;
    this.aInitCustomer = [];
    this.eInitIndex = this.eIndex;
  }

  // #################### DEEP COPY FOR THE MAPS ########################
  static mapDeepCopy(rhs) {
    const deepCopy = new Map();

    for (const [key, value] of rhs) {
      deepCopy.set(key, new NodeX(value));
    }
    return deepCopy;
  }

  setStatistic(data) {
    this.allEdges = new SetX(this.allInitEdges);
    this.active = new SetX(this.initActive);
    this.activeEmployee = new SetX(this.initActiveEmployee);

    this.mPartnerGroup = ChartDataX.mapDeepCopy(this.mInitPartnerGroup);
    this.mPartner = ChartDataX.mapDeepCopy(this.mInitPartner);
    this.mLocation = ChartDataX.mapDeepCopy(this.mInitLocation);
    this.mForm = ChartDataX.mapDeepCopy(this.mInitForm);
    this.mEmployee = ChartDataX.mapDeepCopy(this.mInitEmployee);
    this.mCustomer = ChartDataX.mapDeepCopy(this.mInitCustomer);

    let activeEmployeeInput = document.querySelector(
      ".dataChooserContainer .active-employee > input"
    );

    this.aCustomer = this.aInitCustomer.slice();
    this.eIndex = this.eInitIndex;

    for (let i = 0; i < data.length; ++i) {
      const partnerGroup = data[i];
      const partnerGroupId = partnerGroup.partnergroup.id;
      const partnerGroupNode = this.mPartnerGroup.get(partnerGroupId);

      if (!partnerGroupNode) {
        console.log(
          "Partnergroup with ID: " +
            partnerGroupId +
            " not found in dashboard-data!"
        );
        continue;
      }

      const partners = partnerGroup.partners;

      for (let j = 0; j < partners.length; ++j) {
        const partner = partners[j];
        const partnerId = partner.partner.id;
        const partnerNode = this.mPartner.get(partnerId);

        if (!partnerNode) {
          console.log(
            "Partner with ID: " + partnerId + " not found in dashboard-data!"
          );
          continue;
        }

        const partnerCustomers = partner.customers;

        for (let k = 0; k < partnerCustomers.length; ++k) {
          const partnerCustomer = partnerCustomers[k];

          const employee = partnerCustomer.employee;
          const employeeId = employee.id;
          const employeeNode = this.mEmployee.get(employeeId);
          var aktiveForPartner = employeeNode.r.filter(
            (e_data) => e_data.partner_id == partnerId
          );

          if (!employeeNode) {
            console.log(
              "Employee with ID: " +
                employeeId +
                " not found in dashboard-data!"
            );
            continue;
          } else if (
            activeEmployeeInput &&
            activeEmployeeInput.checked &&
            !aktiveForPartner[0].active &&
            !aktiveForPartner[0].active_for_partner
          ) {
            continue;
          }

          const customers = partnerCustomer.customers;

          for (let l = 0; l < customers.length; ++l) {
            const customer = customers[l];
            const customerId = customer.id;
            const customerCreatedAt = customer.createdAt;
            let customerNode;

            if (!(customerNode = this.mCustomer.get(customerId))) {
              customerNode = this.mCustomer
                .set(customerId, new NodeX(customer))
                .get(customerId);
              this.aCustomer.push([customerId, customerCreatedAt]);
            } else {
              customerNode.addRef(customer);
            }

            partnerGroupNode.addEdge(this.eIndex);
            partnerNode.addEdge(this.eIndex);
            employeeNode.addEdge(this.eIndex);
            if (customer.form) {
              const formId = customer.form;
              const formNode = this.mForm.get(formId);

              if (formNode) {
                formNode.addEdge(this.eIndex);
                const formActive = formNode.refs[0].active;
                if (formActive) {
                  this.active.add(this.eIndex);
                }
              } else {
                console.log(
                  "Form with ID: " + formId + " not found in dashboard-data!"
                );
              }
            }
            if (customer.location) {
              const locationId = customer.location;
              const locationNode = this.mLocation.get(locationId);
              if (locationNode) {
                locationNode.addEdge(this.eIndex);
              } else {
                console.log(
                  "Location with ID: " +
                    locationId +
                    " not found in dashboard-data!"
                );
              }
            }

            customerNode.addEdge(this.eIndex);
            this.allEdges.add(this.eIndex);
            ++this.eIndex;
          }
        }
      }
    }
  }

  // ######## CHARTDATAX-GETTERS ########
  getEdgesFromType(type) {
    let ret = new SetX();
    let edgesOfType;
    switch (type) {
      case "ACTIVE":
        return new SetX(this.active);
      case "CUSTOMER":
        edgesOfType = this.mCustomer;
        break;
      case "EMPLOYEE":
        edgesOfType = this.mEmployee;
        break;
      case "FORM":
        edgesOfType = this.mForm;
        break;
      case "LOCATION":
        edgesOfType = this.mLocation;
        break;
      case "PARTNER":
        edgesOfType = this.mPartner;
        break;
      case "PARTNERGROUP":
        edgesOfType = this.mPartnerGroup;
        break;
    }

    for (let node of edgesOfType.values()) {
      ret = SetX.union(ret, node.edges);
    }

    return ret;
  }

  getNameColorEdgesFromId(id) {
    let ret = this.mEmployee.get(id);
    if (ret) return [ret.refs[0].name, ret.color, ret.edges];

    ret = this.mPartner.get(id);
    if (ret) return [ret.refs[0].partner.name, ret.color, ret.edges];

    ret = this.mPartnerGroup.get(id);
    if (ret) return [ret.refs[0].partnergroup.name, ret.color, ret.edges];

    ret = this.mForm.get(id);
    if (ret) return [ret.refs[0].name, ret.color, ret.edges];

    ret = this.mLocation.get(id);
    if (ret) return [ret.refs[0].name, ret.color, ret.edges];

    ret = this.mCustomer.get(id);
    if (ret) return [ret.refs[0].createdAt, ret.color, ret.edges];
  }

  // ######## CHARTDATAX-GET-ARRAY-DATA-METHOD ########
  /*
        X,Y IS ONE OF { EMPLOYEE, EMPLOYEE, FORM, LOCATION, PARTNER, PARTNERGROUP }

        CUSTOMER-ARRAY : [ [id, createdAt], [id, createdAt], ... ]
        X,Y-ARRAY: [ [id, name, color], [id, name, color], ... ]

        getArrayData('EMPLOYEE', edges)
            returns EMPLOYEE-ARRAY
            ! RETURNED VALUES ARE CONNECTED WITH ALL EDGES, WHICH WHERE GIVEN IN THE ARGUMENTS !
    */
  getArrayData(type, edges) {
    const ret = [];

    switch (type) {
      case "CUSTOMER":
        for (let customer of this.mCustomer) {
          if (SetX.intersectionIsNotEmpty(customer[1].edges, edges)) {
            const customerId = customer[1].refs[0].id;
            const formId = customer[1].refs[0].form;
            const locationId = customer[1].refs[0].location;
            const customerCreatedAt = customer[1].refs[0].createdAt;
            ret.push([customerId, customerCreatedAt, formId, locationId]);
          }
        }
        break;
      case "EMPLOYEE":
        for (let employee of this.mEmployee) {
          if (SetX.intersectionIsNotEmpty(employee[1].edges, edges)) {
            const employeeId = employee[1].refs[0].id;
            let employeeName = employee[1].refs[0].name;
            const newColor = employee[1].color;
            const isActive = new Array();
            for (let partner of employee[1].refs) {
              isActive.push({
                p_id: partner.partner_id,
                p_active: partner.active_for_partner && partner.active,
              });
            }
            employeeName =
              employeeName.charAt(0).toUpperCase() + employeeName.slice(1);
            ret.push([employeeId, employeeName, newColor, isActive]);
          }
        }
        break;
      case "FORM":
        for (let form of this.mForm) {
          if (SetX.intersectionIsNotEmpty(form[1].edges, edges)) {
            const formId = form[1].refs[0].id;
            let formName = form[1].refs[0].name;
            const formVersion = form[1].refs[0].version;
            const formActive = form[1].refs[0].active;
            formName = formName.charAt(0).toUpperCase() + formName.slice(1);
            ret.push([formId, formName, formVersion, formActive]);
          }
        }
        break;
      case "LOCATION":
        for (let location of this.mLocation) {
          if (SetX.intersectionIsNotEmpty(location[1].edges, edges)) {
            const locationId = location[1].refs[0].id;
            let locationName = location[1].refs[0].name;
            const locationAddress = location[1].refs[0].address;
            locationName =
              locationName.charAt(0).toUpperCase() + locationName.slice(1);
            ret.push([locationId, locationName, locationAddress]);
          }
        }
        break;
      case "PARTNER":
        for (let partner of this.mPartner) {
          if (SetX.intersectionIsNotEmpty(partner[1].edges, edges)) {
            var partnerId = partner[1].refs[0].partner.id;
            var partnerName = partner[1].refs[0].partner.name;
            partnerName =
              partnerName.charAt(0).toUpperCase() + partnerName.slice(1);
            const newColor = partner[1].color;
            ret.push([partnerId, partnerName, newColor]);
          }
        }
        break;
      case "PARTNERGROUP":
        for (let partnergroup of this.mPartnerGroup) {
          if (SetX.intersectionIsNotEmpty(partnergroup[1].edges, edges)) {
            const partnerGroupId = partnergroup[1].refs[0].partnergroup.id;
            let partnerGroupName = partnergroup[1].refs[0].partnergroup.name;
            partnerGroupName =
              partnerGroupName.charAt(0).toUpperCase() +
              partnerGroupName.slice(1);
            const newColor = partnergroup[1].color;
            ret.push([partnerGroupId, partnerGroupName, newColor]);
          }
        }
        break;
    }
    return ret;
  }
  // ######## CHARTDATAX-GET-ARRAY-DATA-METHOD END ########
}
// ################ CHARTDATAX-CLASS END ################
